
















































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { SynonymTypeConfig } from '@empathybroker/tsclient-play/dist/models/instance/synonym-type-config';

import { mapGetters } from 'vuex';

import { CrudList, DataTable, NoDataFound } from '../../components';

import { FilterIdEnum } from '../../enums';

import { CrudListMixin } from '../../mixins/crud-list.mixin';

import { DataTableColumn } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { CONFIG_CONSTS } from '../../store/config/config.consts';

import SynonymsForm from '../../views/synonyms/synonyms-form.view.vue';

export default {
  name: 'synonyms-list',
  components: {
    CrudList,
    DataTable,
    NoDataFound
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance
    }),
    tableColumns: function (): DataTableColumn[] {
      return this.columns.filter((column: DataTableColumn) => {
        if (column.id === 'type') {
          return (SynonymsForm as any).computed.isTypeVisible.bind(this)();
        }
        if (column.id === FilterIdEnum.LANG) {
          return (SynonymsForm as any).computed.isLangVisible.bind(this)();
        }
        return true;
      });
    }
  },
  mixins: [CrudListMixin],
  data: function () {
    const messages = this.$epb.messages.tools.synonyms;
    return {
      dataType: ActionTypeEnum.SYNONYM,
      routes: {
        create: ROUTER_CONSTS.routes.synonyms.create,
        update: ROUTER_CONSTS.routes.synonyms.update
      },
      columns: [
        {
          id: 'type',
          text: messages.fields.type.label,
          sortable: true,
          width: '8rem'
        }, {
          id: 'lang',
          text: this.$epb.messages.filters.names.lang,
          sortable: true
        }, {
          id: 'synonyms',
          text: messages.fields.synonyms.label,
          width: '200%'
        }, {
          id: 'hyponyms',
          text: messages.fields.hyponyms.label
        }, {
          id: 'meta.updateDate',
          text: messages.fields.updateDate.label,
          sortable: true
        }, {
          id: 'meta.user',
          text: messages.fields.user.label,
          sortable: true
        }, {
          id: 'enabled',
          text: messages.fields.enabled.label,
          sortable: true
        }
      ],
      messages: messages
    };
  },
  methods: {
    getTypeText: function (type: string): string {
      const typeConfig = this.instanceConfig.tools[this.dataType].types.find((typeCfg: SynonymTypeConfig) => (typeCfg.id === type));
      if (!!typeConfig) {
        const typeValuesMessages = this.messages.fields.type.values;
        return (typeConfig.prettyName || typeValuesMessages[type] || typeConfig.id);
      }
      return type;
    }
  }
};

